import { render, staticRenderFns } from "./gexinghua.vue?vue&type=template&id=b5c0c832&scoped=true&"
import script from "./gexinghua.vue?vue&type=script&lang=js&"
export * from "./gexinghua.vue?vue&type=script&lang=js&"
import style0 from "./gexinghua.vue?vue&type=style&index=0&id=b5c0c832&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c0c832",
  null
  
)

export default component.exports